import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

/* ==========================================================================
   AppShell — main layout wrapper (header slot + scrollable content).
   Optimised for 10.2" tablet in portrait.
   ========================================================================== */

export interface AppShellProps {
  /** Header component — typically <Header />. */
  header?: ReactNode;
  /** Main page content. */
  children: ReactNode;
  /** Extra class on the content area. */
  className?: string;
  /** Remove default content padding. */
  noPadding?: boolean;
}

export function AppShell({
  header,
  children,
  className,
  noPadding = false,
}: AppShellProps) {
  return (
    <div className="flex h-dvh flex-col bg-surface-base overflow-hidden">
      {/* Header slot */}
      {header}

      {/* Scrollable content */}
      <main
        className={cn(
          'flex-1 overflow-y-auto',
          !noPadding && 'px-5 py-6',
          /* Constrain content width on very large screens */
          'mx-auto w-full max-w-3xl',
          className,
        )}
      >
        {children}
      </main>
    </div>
  );
}
